import moment from 'moment';

export default {
  Today: [moment().startOf('day'), moment()],
  Yesterday: [
    moment()
      .subtract(1, 'day')
      .startOf('day'),
    moment()
      .subtract(1, 'day')
      .endOf('day'),
  ],
  'Last 7 Days': [
    moment()
      .subtract(7, 'day')
      .startOf('day'),
    moment(),
  ],
  'Last 30 days': [
    moment()
      .subtract(30, 'day')
      .startOf('day'),
    moment(),
  ],
  'This year': [moment().startOf('year'), moment()],
  'Last 5 years': [moment().subtract(5, 'year'), moment()],
};



// WEBPACK FOOTER //
// ./src/components/ChartView/DateRanges.js